import axios from "../utils/axios";

// ==========================================
// Warehouses
// ==========================================

export const getWarehouses = async (params) => {
    const response = await axios.get("/admin/warehouses", { params });
    return response.data;
};

export const getWarehouseById = async (id) => {
    const response = await axios.get(`/admin/warehouses/${id}`);
    return response.data;
};

export const createWarehouse = async (data) => {
    const response = await axios.post("/admin/warehouses", data);
    return response.data;
};

export const updateWarehouse = async (id, data) => {
    const response = await axios.put(`/admin/warehouses/${id}`, data);
    return response.data;
};

export const deleteWarehouse = async (id) => {
    const response = await axios.delete(`/admin/warehouses/${id}`);
    return response.data;
};

// ==========================================
// Inventory
// ==========================================

export const getInventory = async (params) => {
    const response = await axios.get("/admin/inventory", { params });
    return response.data;
};

export const adjustInventory = async (data) => {
    const response = await axios.post("/admin/inventory/adjust", data);
    return response.data;
};

export const getInventoryMovements = async (params) => {
    const response = await axios.get("/admin/inventory/movements", { params });
    return response.data;
};
